import { render } from "./Record.vue?vue&type=template&id=2e881e25&scoped=true"
import script from "./Record.vue?vue&type=script&lang=js"
export * from "./Record.vue?vue&type=script&lang=js"

import "./Record.vue?vue&type=style&index=0&id=2e881e25&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-2e881e25"

export default script